import { StaffMember } from '@/app/config/staff'
import { MouseEvent, useState } from 'react'
import { cn } from '@/util/cn'
import Typography from '@/app/components/typography'
import { useIsMobile } from '@/app/util/use-media-query'

type Props = { member: StaffMember }

const Overlay = ({ member }: Props) => {
    const [isTapped, setIsTapped] = useState(false)
    const isMobile = useIsMobile()
    
    const href = member.channelURL || `/search/${encodeURIComponent(member.tag)}`

    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
        if (isMobile && !isTapped) {
            e.preventDefault()
            setIsTapped(true)
        }
    }

    return (
        <a
            href={href}
            onClick={handleClick}
            rel="noopener noreferrer"
            className={cn(
                'absolute inset-0 flex flex-col items-center justify-center bg-black/50 transition-opacity ease-out duration-100 md:opacity-0 md:group-hover:opacity-100',
                isTapped ? 'opacity-100' : 'opacity-0',
            )}
        >
            <Typography
                className="text-giphyYellow mb-4"
                variant="text-xl"
                fontWeight="bold"
            >
                {member.name}
            </Typography>

            <div className="grid place-items-center h-10 px-4 rounded-full bg-giphyDarkGrey">
                <Typography
                    variant="text-base"
                    fontWeight="bold"
                    className={cn(
                        'text-giphyWhite italic lowercase',
                    )}
                >
                    #{member.tag}
                </Typography>
            </div>
        </a>
    )
}

export default Overlay
